import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { createLeadRegistry, getRegistryLeadTypes, getLeadSubStatuses, logError } from '../api';
import { getUserId, getSalesRepId } from '../services/AuthService';

const LeadEventModal = ({ show, handleClose, leadId, onEventAdded }) => {
    const [registryTypeId, setRegistryTypeId] = useState('');
    const [subTypeId, setSubTypeId] = useState('');
    const [comments, setComments] = useState('');
    const [followUpDate, setFollowUpDate] = useState('');
    const [registryTypes, setRegistryTypes] = useState([]);
    const [subTypes, setSubTypes] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            loadData();
            resetForm();
        }
    }, [show]);

    const loadData = async () => {
        try {
            const registryTypesData = await getRegistryLeadTypes();
            setRegistryTypes(registryTypesData);
        } catch (error) {
            logError(error);
            console.error('Error loading data:', error);
        }
    };

    const resetForm = () => {
        setRegistryTypeId('');
        setSubTypeId('');
        setComments('');
        setFollowUpDate('');
        setSubTypes([]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const leadRegistry = {
                leadId: parseInt(leadId),
                registryTypeId: registryTypeId ? parseInt(registryTypeId) : null,
                subStatusId: subTypeId ? parseInt(subTypeId) : null,
                salesRepId: getSalesRepId() || null,
                createdByUserId: getUserId(),
                comments: comments || null,
                followUpDate: followUpDate || null
            };

            await createLeadRegistry(leadRegistry);
            onEventAdded();
            handleClose();
        } catch (error) {
            logError(error);
            console.error('Error creating lead event:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Añadir Registro</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Tipo de Registro</Form.Label>
                                <Form.Select
                                    data-testid="registry-type-select"
                                    value={registryTypeId}
                                    onChange={async (e) => {
                                        const value = e.target.value;
                                        setRegistryTypeId(value);
                                        setSubTypeId('');
                                        
                                        if (value) {
                                            try {
                                                const subTypesData = await getLeadSubStatuses(value);
                                                setSubTypes(subTypesData || []);
                                            } catch (error) {
                                                console.error('Error loading sub types:', error);
                                                setSubTypes([]);
                                            }
                                        } else {
                                            setSubTypes([]);
                                        }
                                    }}
                                    required
                                >
                                    <option value="">Seleccionar tipo...</option>
                                    {registryTypes.map(type => (
                                        <option key={type.valueId} value={type.valueId}>
                                            {type.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            {subTypes.length > 0 && (
                                <Form.Group className="mb-3">
                                    <Form.Label>Detalle de Estado</Form.Label>
                                    <Form.Select
                                        data-testid="sub-type-select"
                                        value={subTypeId}
                                        onChange={(e) => setSubTypeId(e.target.value)}
                                    >
                                        <option value="">Seleccionar detalle...</option>
                                        {subTypes.map(subType => (
                                            <option key={subType.valueId} value={subType.valueId}>
                                                {subType.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                    <Form.Group className="mb-3">
                        <Form.Label>Comentarios <small className="text-muted">(opcional)</small></Form.Label>
                        <Form.Control
                            data-testid="comments-textarea"
                            as="textarea"
                            rows={3}
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            placeholder="Comentarios o notas..."
                            maxLength={255}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Fecha de Seguimiento</Form.Label>
                        <Form.Control
                            data-testid="follow-up-date-input"
                            type="date"
                            value={followUpDate}
                            onChange={(e) => setFollowUpDate(e.target.value)}
                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                            style={{ cursor: 'pointer' }}
                            min={new Date().toISOString().split('T')[0]}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        data-testid="save-event-btn"
                        variant="primary" 
                        type="submit" 
                        disabled={loading || !registryTypeId}
                    >
                        {loading ? 'Guardando...' : 'Guardar'}
                    </Button>
                    <Button 
                        data-testid="cancel-event-btn"
                        variant="secondary" 
                        onClick={handleClose}
                    >
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default LeadEventModal;